import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { completeSecondFactorConfiguration } from 'actions/seguridad';
import { redirectUriPostSecondFactorSelector } from 'store/selectors';

import CardSuccess from 'components/CardSuccess';
import { SEGURIDAD_ROUTE } from 'constants/RouterConstants';
import ButtonSolid from 'components/ButtonSolid';

const CorreoModificadoY2FAExitoso = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const redirectUriPostSecondFactor = useSelector(
    redirectUriPostSecondFactorSelector,
  );
  return (
    <CardSuccess
      title="El correo ha sido modificado y el segundo factor de autenticación ha sido activado exitosamente"
      description="A partir de ahora cuando inicies sesión se enviará un código al nuevo correo, el cual que deberás ingresar para autenticarte"
      extra2={
        <ButtonSolid
          text="Continuar"
          handleClick={() => {
            dispatch(completeSecondFactorConfiguration());
            if (redirectUriPostSecondFactor)
              window.location.href = redirectUriPostSecondFactor;
            else history.push(SEGURIDAD_ROUTE);
          }}
        />
      }
    />
  );
};

export default CorreoModificadoY2FAExitoso;
